import ArticleEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/article_embed';
import ArticleGridEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/article_grid_embed';
import BrandCalloutEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/callouts/brand';
import CalloutEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/callout_embed';
import CategoryCalloutEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/callouts/category';
import ComparisonShoppingPageCardManager from '@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_card_manager';
import CSPMiniGridEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/csp_mini_grid_embed';
import FollowButtonContainer from '@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_button_container';
import HandpickedCalloutEmbed from '@reverbdotcom/discovery-ui/dist/components/embeds/callouts/handpicked';
import VideoEmbed from '@reverbdotcom/commons/dist/components/video_embed';

window.Reverb = { ...window.Reverb,
  ArticleEmbed,
  ArticleGridEmbed,
  BrandCalloutEmbed,
  CalloutEmbed,
  CategoryCalloutEmbed,
  ComparisonShoppingPageCardManager,
  CSPMiniGridEmbed,
  FollowButtonContainer,
  HandpickedCalloutEmbed,
  // this component is still embedded in articles, leaving it defined but as a no-op
  LPAlbumRowEmbed: () => { return null; },
  VideoEmbed,
};



// WEBPACK FOOTER //
// ./javascripts/articles.js